/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function SiteGroup({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M11.25 1.398a1.6 1.6 0 0 1 1.6 1.6v1.4h1.4a1.6 1.6 0 0 1 1.6 1.6v7a1.6 1.6 0 0 1-1.6 1.6h-9a1.6 1.6 0 0 1-1.6-1.6v-1.4h-1.4a1.6 1.6 0 0 1-1.6-1.6v-7a1.6 1.6 0 0 1 1.6-1.6zm1.6 8.6a1.6 1.6 0 0 1-1.6 1.6h-6.4v1.4c0 .221.18.4.4.4h9a.4.4 0 0 0 .4-.4v-7a.4.4 0 0 0-.4-.4h-1.4zm-10.6-7.4a.4.4 0 0 0-.4.4v7c0 .221.18.4.4.4h9a.4.4 0 0 0 .4-.4v-7a.4.4 0 0 0-.4-.4zm6 1.8a.6.6 0 1 1 0 1.2h-4a.6.6 0 1 1 0-1.2z" /></svg>;
}
;